module.exports = __webpack_public_path__ + "img/img16.59d302e2.svg";